module.exports = __webpack_public_path__ + "img/qr-code-dummy.978ed037.svg";